import { Validator } from 'vee-validate';

const unique = {
  getMessage(field) {
    return `Such ${field} already exists.`;
  },
  validate(value, list) {
    if (value) {
      console.log(value, list, list.indexOf(value));
      return list.indexOf(value) === -1;
    }
    return false;
  }
};

Validator.extend('unique', unique, {
  immediate: false
});

let instance = new Validator({ trueField: 'unique' });



// WEBPACK FOOTER //
// ./src/validation/unique.js